import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import Loader from "../components/Loader/Loader";

const NoConnectionPage = lazy(() => import("../pages/NoConnectionPage/NoConnectionPage"));

export const noConnectionRouter = createBrowserRouter([
    {
        path: "*",
        element: (
            <Suspense fallback={<Loader />}>
                <NoConnectionPage />
            </Suspense>
        ),
    },
]);